module.exports = __webpack_public_path__ + "img/free_fee.fc98316d.png";